<template>
    <ul class="tips-list pl-5 pb-2">
        <li
            class="flex mb-1"
            v-for="(tip, tIndex) in tipsFormatted"
            :key="'tip-' + tIndex"
        >
            <span class="pr-2 font-bold w-2/12">
                {{ tip.label }}
            </span>
            <span class="pl-2 pr-1 text-sm w-10/12">
                {{ tip.value }}
            </span>
        </li>
    </ul>
</template>
<script setup>
import { computed } from 'vue';

const props = defineProps({
    tips: {
        type: [String, Array],
        required: true,
    },
});

const tipsFormatted = computed(() => {
    if (!props.tips) {
        return [];
    }

    try {
        return Array.isArray(props.tips) ? props.tips : JSON.parse(props.tips);
    } catch (e) {
        return props.tips;
    }
});
</script>
